import { FiChevronRight } from "react-icons/fi";
import developerLogo from "../../../assets-user/Slowgan.png";

const BhubaneswarTopDeveloper = () => {
  const developers = [
    {
      id: 1,
      name: "Adani Realty",
      location: "Bhubaneswar",
      totalProjects: "12",
      experience: 14,
      noOfCity: 5,
      logo: developerLogo,
    },
    {
      id: 2,
      name: "DN Homes",
      location: "Bhubaneswar",
      totalProjects: "18",
      experience: 20,
      noOfCity: 4,
      logo: developerLogo,
    },
    {
      id: 3,
      name: "Trident Properties",
      location: "Bhubaneswar",
      totalProjects: "10",
      experience: 12,
      noOfCity: 3,
      logo: developerLogo,
    },
  ];

  return (
    <div className="">
      <div className="mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-sans font-semibold text-lg sm:text-xl lg:text-2xl text-gray-900">
            Top Developer in Bhubaneswar
          </h2>

          <button className="flex items-center gap-1 text-red-600 hover:text-red-700 font-medium text-sm sm:text-base transition-colors">
            View All
            <FiChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
          </button>
        </div>

        {/* Developers Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-5 lg:gap-6">
          {developers.map((developer) => (
            <div
              key={developer.id}
              className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden cursor-pointer hover:shadow-xl transition-all duration-300 hover:scale-[1.03]"
            >
              <div className="p-4 sm:p-5">
                <div className="flex items-start gap-3 sm:gap-4 mb-4">
                  {/* Logo */}
                  <div className="flex-shrink-0 p-2 bg-[#e5e5e5] rounded-xl">
                    <img
                      src={developer.logo}
                      alt={developer.name}
                      className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 object-cover rounded-lg"
                    />
                  </div>

                  {/* Name + Location */}
                  <div className="flex-1">
                    <h3 className="font-sans font-semibold text-base sm:text-lg text-gray-900 mb-1">
                      {developer.name}
                    </h3>
                    <p className="font-sans font-normal text-xs sm:text-sm text-gray-500">
                      {developer.location}
                    </p>

                    {/* Stats */}
                    <div className="flex items-center justify-between gap-2 mt-4">
                      <div>
                        <div className="font-sans font-bold text-lg sm:text-xl text-gray-900">
                          {developer.totalProjects}
                        </div>
                        <div className="font-sans font-normal text-[10px] sm:text-xs text-gray-600 whitespace-nowrap">
                          Total Projects
                        </div>
                      </div>
                      <div>
                        <div className="font-sans font-bold text-lg sm:text-xl text-gray-900">
                          {developer.experience}
                        </div>
                        <div className="font-sans font-normal text-[10px] sm:text-xs text-gray-600 whitespace-nowrap">
                          Experience
                        </div>
                      </div>
                      <div>
                        <div className="font-sans font-bold text-lg sm:text-xl text-gray-900">
                          {developer.noOfCity}
                        </div>
                        <div className="font-sans font-normal text-[10px] sm:text-xs text-gray-600 whitespace-nowrap">
                          No. of City
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Footer */}
                <div className="flex items-center justify-between mt-4 pt-4 px-2 border-t border-gray-100">
                  <p className="text-sm sm:text-base font-medium text-gray-500 underline underline-offset-4">
                    25+ Projects
                  </p>

                  <button className="px-4 py-2 border border-[#F04438] text-[#F04438] font-medium text-sm sm:text-base rounded-lg hover:bg-[#F04438] hover:text-white transition-all duration-300">
                    View Details
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BhubaneswarTopDeveloper;

// import { useState, useEffect } from "react";
// import { FiChevronRight } from "react-icons/fi";
// import developerLogo from "../../../assets-user/Slowgan.png";

// const BhubaneswarTopDeveloper = ({ title }) => {
//   const [loading, setLoading] = useState(true);

//   const developers = [
//     {
//       id: 1,
//       name: "Adani Realty",
//       location: "Bhubaneswar",
//       totalProjects: "05",
//       experience: 10,
//       noOfCity: 3,
//       logo: developerLogo,
//     },
//     {
//       id: 2,
//       name: "Adani Realty",
//       location: "Bhubaneswar",
//       totalProjects: "05",
//       experience: 10,
//       noOfCity: 3,
//       logo: developerLogo,
//     },
//     {
//       id: 3,
//       name: "Adani Realty",
//       location: "Bhubaneswar",
//       totalProjects: "05",
//       experience: 10,
//       noOfCity: 3,
//       logo: developerLogo,
//     },
//   ];

//   useEffect(() => {
//     const timer = setTimeout(() => setLoading(false), 1500);
//     return () => clearTimeout(timer);
//   }, []);

//   useEffect(() => {
//     // Load AOS CSS
//     const link = document.createElement("link");
//     link.rel = "stylesheet";
//     link.href = "https://unpkg.com/aos@2.3.1/dist/aos.css";
//     document.head.appendChild(link);

//     // Load AOS JS
//     const script = document.createElement("script");
//     script.src = "https://unpkg.com/aos@2.3.1/dist/aos.js";
//     script.async = true;

//     script.onload = () => {
//       if (window.AOS) {
//         window.AOS.init({
//           duration: 800,
//           easing: "ease-in-out",
//           once: false,
//           mirror: true,
//           offset: 100,
//         });
//       }
//     };

//     document.body.appendChild(script);

//     return () => {
//       if (document.head.contains(link)) {
//         document.head.removeChild(link);
//       }
//       if (document.body.contains(script)) {
//         document.body.removeChild(script);
//       }
//     };
//   }, []);

//   return (
//     <div className="">
//       <div className="mx-auto">
//         {/* Header */}
//         <div
//           className="flex items-center justify-between mb-6"
//           data-aos="fade-down"
//           data-aos-duration="600"
//         >
//           {loading ? (
//             <div className="h-6 sm:h-8 w-64 bg-gray-300 rounded animate-pulse" />
//           ) : (
//             <h2 className="font-sans font-semibold text-lg sm:text-xl lg:text-2xl text-gray-900">
//               Top Developer in Bhubaneswar
//             </h2>
//           )}

//           {!loading && (
//             <button
//               className="flex items-center gap-1 text-red-600 hover:text-red-700 font-medium text-sm sm:text-base transition-colors"
//               data-aos="fade-left"
//               data-aos-duration="500"
//               data-aos-delay="100"
//             >
//               View All
//               <FiChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
//             </button>
//           )}
//         </div>

//         {/* Developers Grid - Fixed to show all 3 cards */}
//         <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-5 lg:gap-6">
//           {(loading ? Array(3).fill(0) : developers).map((developer, index) => (
//             <div
//               key={developer?.id || index}
//               className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden cursor-pointer hover:shadow-xl transition-all duration-300 hover:scale-[1.03]"
//               data-aos="fade-up"
//               data-aos-delay={index * 150}
//               data-aos-duration="800"
//             >
//               {/* Developer Header */}
//               <div className="p-4 sm:p-5">
//                 <div className="flex items-start gap-3 sm:gap-4 mb-4">
//                   {/* Logo */}
//                   <div
//                     className="flex-shrink-0 p-2 bg-[#e5e5e5] rounded-xl"
//                     data-aos="zoom-in"
//                     data-aos-delay={index * 150 + 100}
//                     data-aos-duration="500"
//                   >
//                     {loading ? (
//                       <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-gray-300 rounded-lg animate-pulse" />
//                     ) : (
//                       <img
//                         src={developer.logo}
//                         alt={developer.name}
//                         className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 object-cover rounded-lg"
//                       />
//                     )}
//                   </div>

//                   {/* Name and Location */}
//                   <div className="flex-1">
//                     {loading ? (
//                       <>
//                         <div className="h-4 sm:h-5 w-32 bg-gray-300 rounded animate-pulse mb-1" />
//                         <div className="h-3 w-24 bg-gray-200 rounded animate-pulse" />
//                         <div className="flex items-center justify-between gap-2 mt-4">
//                           {Array(3)
//                             .fill(0)
//                             .map((_, i) => (
//                               <div key={i} className="space-y-1">
//                                 <div className="h-4 w-8 bg-gray-300 rounded" />
//                                 <div className="h-3 w-16 bg-gray-200 rounded" />
//                               </div>
//                             ))}
//                         </div>
//                       </>
//                     ) : (
//                       <>
//                         <h3
//                           className="font-sans font-semibold text-base sm:text-lg text-gray-900 mb-1"
//                           data-aos="fade-right"
//                           data-aos-delay={index * 150 + 200}
//                           data-aos-duration="500"
//                         >
//                           {developer.name}
//                         </h3>
//                         <p
//                           className="font-sans font-normal text-xs sm:text-sm text-gray-500"
//                           data-aos="fade-right"
//                           data-aos-delay={index * 150 + 250}
//                           data-aos-duration="500"
//                         >
//                           {developer.location}
//                         </p>

//                         {/* Stats */}
//                         <div
//                           className="flex items-center justify-between gap-2 mt-4"
//                           data-aos="fade-up"
//                           data-aos-delay={index * 150 + 300}
//                           data-aos-duration="600"
//                         >
//                           <div>
//                             <div
//                               className="font-sans font-bold text-lg sm:text-xl text-gray-900"
//                               data-aos="flip-up"
//                               data-aos-delay={index * 150 + 350}
//                               data-aos-duration="400"
//                             >
//                               {developer.totalProjects}
//                             </div>
//                             <div className="font-sans font-normal text-[10px] sm:text-xs text-gray-600 whitespace-nowrap">
//                               Total Projects
//                             </div>
//                           </div>
//                           <div>
//                             <div
//                               className="font-sans font-bold text-lg sm:text-xl text-gray-900"
//                               data-aos="flip-up"
//                               data-aos-delay={index * 150 + 400}
//                               data-aos-duration="400"
//                             >
//                               {developer.experience}
//                             </div>
//                             <div className="font-sans font-normal text-[10px] sm:text-xs text-gray-600 whitespace-nowrap">
//                               Experience
//                             </div>
//                           </div>
//                           <div>
//                             <div
//                               className="font-sans font-bold text-lg sm:text-xl text-gray-900"
//                               data-aos="flip-up"
//                               data-aos-delay={index * 150 + 450}
//                               data-aos-duration="400"
//                             >
//                               {developer.noOfCity}
//                             </div>
//                             <div className="font-sans font-normal text-[10px] sm:text-xs text-gray-600 whitespace-nowrap">
//                               No. of City
//                             </div>
//                           </div>
//                         </div>
//                       </>
//                     )}
//                   </div>
//                 </div>
//                 <div
//                   className="flex items-center justify-between mt-4 pt-4 px-2"
//                   data-aos="fade-up"
//                   data-aos-delay={index * 150 + 500}
//                   data-aos-duration="500"
//                 >
//                   <p className="text-sm sm:text-base font-medium text-gray-500 underline underline-offset-4">
//                     25+ Projects
//                   </p>

//                   <button
//                     className="px-4 py-2 border border-[#F04438] text-[#F04438] font-medium text-sm sm:text-base rounded-lg hover:bg-[#F04438] hover:text-white transition-all duration-300"
//                     data-aos="zoom-in"
//                     data-aos-delay={index * 150 + 550}
//                     data-aos-duration="400"
//                   >
//                     View Details
//                   </button>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BhubaneswarTopDeveloper;
